// React hooks over the Brain data layer. Each resource resolves to a single
// lifecycle status the surfaces render on: loading | ok | empty | disabled | error.
import { useCallback, useEffect, useState } from "react";
import { fetchBrain } from "./brainApi";

// `isEmpty(data)` lets a caller declare what "empty" means for its payload.
export function useBrainResource(endpoint, { params, isEmpty, skip } = {}) {
  const [state, setState] = useState({ status: "loading", data: null, error: null });

  const load = useCallback(async () => {
    if (skip) {
      setState({ status: "disabled", data: null, error: null });
      return;
    }
    setState((s) => ({ ...s, status: "loading" }));
    const res = await fetchBrain(endpoint, params);
    if (res.status === "ok") {
      const empty = typeof isEmpty === "function" ? isEmpty(res.data) : false;
      setState({ status: empty ? "empty" : "ok", data: res.data, error: null });
    } else if (res.status === "disabled") {
      setState({ status: "disabled", data: null, error: null });
    } else {
      setState({ status: "error", data: null, error: res.error });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint, JSON.stringify(params), skip]);

  useEffect(() => {
    load();
  }, [load]);

  return { ...state, reload: load };
}
